import { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from 'services';
import { cookieService } from 'services/cookieService';
import { ERROR_IMAGE } from 'settings';
import { Divider, If } from 'shared';
import Badge from 'shared/Badge';
import { userActions } from 'store/features';
import { IAccounts } from 'types/interfaces/accounts';

import ArrowRightIcon from '@eduzz/houston-icons/ArrowRight';

import { Item, Image, Info, Name, Email } from './styles';

interface IProps extends IAccounts {
  isMain?: boolean;
}
export const Account: React.FC<IProps> = ({ id, photo, name, email, isMe }) => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const redirectTo = searchParams.get('redirectTo');
  const navigate = useNavigate();

  const defineRedirect = useCallback(async () => {
    try {
      cookieService.setCookie('isRedirected', '1');

      if (!redirectTo && !isMe) {
        await authService.switchAccount(id);
        navigate('/orderbump', { replace: true });
      }

      if (redirectTo) {
        authService.setUserIdCookie(String(id));
        window.location.href = redirectTo;
      }

      dispatch(userActions.setUserAccountSelected(true));
    } catch (error) {}
  }, [navigate, redirectTo, id, isMe, dispatch]);

  return (
    <>
      <Item
        onClick={() => {
          defineRedirect();
        }}
      >
        <If condition={isMe}>
          <Badge text='Principal' />
        </If>
        <Image
          src={photo}
          alt={`Imagem de ${name}`}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = ERROR_IMAGE;
          }}
        />
        <Info>
          <Name>{name}</Name>
          <Email>{email}</Email>
        </Info>
        <ArrowRightIcon size={'small'} />
      </Item>
      <Divider />
    </>
  );
};
